import { render, staticRenderFns } from "./WorkUnit.vue?vue&type=template&id=0724eea5"
import script from "./WorkUnit.vue?vue&type=script&lang=js"
export * from "./WorkUnit.vue?vue&type=script&lang=js"
import style0 from "./WorkUnit.vue?vue&type=style&index=0&id=0724eea5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports